<h2 mat-dialog-title>
    <span *ngIf="selectedForm.HasBeenReOpened" translate>Re-Opened Form</span>
    <span *ngIf="!selectedForm.HasBeenReOpened" translate>Unfinished Version Exists</span>
</h2>
<mat-dialog-content>
    <div style="height: 200px; width: 350px;">
        <div style="font-weight: bold;">{{selectedForm.InstanceName | tylTranslate}}</div>
        <div style="padding-top: 20px;" *ngIf="!selectedForm.HasBeenReOpened">
            <span translate>An unfinished version of this e-Form exists. It was last updated on </span>
            {{lastUpdatedOn | date:'MM/dd/yy'}}
            <span translate> by </span> 
            {{lastUpdatedBy}}
        </div>
        <div style="padding-top: 20px;" *ngIf="selectedForm.HasBeenReOpened">
            <span translate>This form was submitted on</span>
            {{lastUpdatedOn | date:'MM/dd/yy'}}
            <span translate> by </span> 
            {{lastUpdatedBy}}
            <span translate>, but has now been re-opened.</span>
        </div>
        <div style="padding-top: 20px;">
            <span *ngIf="!selectedForm.HasBeenReOpened" translate>Do you want to continue with the unfinished version or abandon it and start over?</span>
            <span *ngIf="selectedForm.HasBeenReOpened" translate>Do you want to continue with the original form or abandon it and start over?</span>
        </div>
        <div style="padding-top: 20px;display: flex; flex-direction: row;">
            <div style="width: 50%; display: flex; flex-direction: row; justify-content: center;">
                <a (click)="continue()" *ngIf="!selectedForm.HasBeenReOpened" translate>Continue with Unfinished</a>
                <a (click)="continue()" *ngIf="selectedForm.HasBeenReOpened" translate>Continue with Original</a>
            </div>
            <div style="width: 50%; display: flex; flex-direction: row; justify-content: center;">
                <a (click)="startOver()" translate>Start Over</a>
            </div>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <div class='flex-footer-left'>

    </div>
    <div class='flex-footer-right'>
        <tyl-button image="cancel.png" label="Cancel" (clickEvent)="cancelClick()"></tyl-button>
    </div>
</mat-dialog-actions>